import React from "react";
import { Modal, Button } from "react-bootstrap";
import { withCookies } from "react-cookie";
import { Spinner } from "react-bootstrap";

const ConfirmationBox = ({
  show,
  handleClose,
  title,
  message,
  confirmationAction,
  loading,
  confirmButtonText,
  closeButtonText,
  size,
}) => {
  return (
    <Modal
      show={show}
      onHide={handleClose}
      size={size ? size : "lg"}
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          {loading ? (
            <Spinner animation="border" size="sm" style={{ color: "#fff" }} />
          ) : closeButtonText ? (
            closeButtonText
          ) : (
            "Cancel"
          )}
        </Button>
        {confirmationAction && (
          <Button
            variant="primary"
            disabled={loading}
            onClick={confirmationAction}
          >
            {loading ? (
              <Spinner animation="border" size="sm" style={{ color: "#fff" }} />
            ) : confirmButtonText ? (
              confirmButtonText
            ) : (
              "Delete"
            )}
          </Button>
        )}
      </Modal.Footer>
    </Modal>
  );
};

export default withCookies(ConfirmationBox);
